import axios from "./axios";


export async function fetchMeetingMinutes(controller) {
  return axios({
    method: "get",
    url: "/meeting_minutes",
    params: controller,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function fetchMeetingMinutesById(id) {
  return axios
    .get(`/meeting_minutes/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function createMeetingMinutes(payload, templateId = null) {
  const params = templateId ? { template_id: templateId } : {};
  return axios
    .post("/meeting_minutes", { meeting_minutes: payload }, { params })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function updateMeetingMinutes(payload) {
  const id = typeof payload === "string" ? payload : payload.id;
  return axios
    .put(`/meeting_minutes/${id}`, { meeting_minutes: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function deleteMeetingMinutes(payload) {
  const id = typeof payload === "string" ? payload : payload.id;
  return axios
    .delete(`/meeting_minutes/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function continueMeetingMinutes(id, meetingDate = null) {
  const params = meetingDate ? { meeting_date: meetingDate } : {};
  return axios
    .post(`/meeting_minutes/${id}/continue_meeting`, {}, { params })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

// Templates
export async function fetchMeetingMinutesTemplates(controller) {
  return axios({
    method: "get",
    url: "/meeting_minutes_templates",
    params: controller,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function fetchMeetingMinutesTemplate(id) {
  return axios
    .get(`/meeting_minutes_templates/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function createMeetingMinutesTemplate(payload) {
  return axios
    .post("/meeting_minutes_templates", { template: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function updateMeetingMinutesTemplate(payload) {
  const id = typeof payload === "string" ? payload : payload.id;
  return axios
    .put(`/meeting_minutes_templates/${id}`, { template: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function deleteMeetingMinutesTemplate(payload) {
  const id = typeof payload === "string" ? payload : payload.id;
  return axios
    .delete(`/meeting_minutes_templates/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

// Meetings
export async function fetchMeetingMinutesMeetings(meetingMinutesId) {
  return axios
    .get(`/meeting_minutes/${meetingMinutesId}/meetings`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function fetchMeetingMinutesMeeting(meetingMinutesId, meetingId) {
  return axios
    .get(`/meeting_minutes/${meetingMinutesId}/meetings/${meetingId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function createMeetingMinutesMeeting(meetingMinutesId, payload, params = {}) {
  return axios
    .post(`/meeting_minutes/${meetingMinutesId}/meetings`, { meeting: payload }, { params })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function updateMeetingMinutesMeeting(meetingMinutesId, meetingId, payload) {
  return axios
    .put(`/meeting_minutes/${meetingMinutesId}/meetings/${meetingId}`, { meeting: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function deleteMeetingMinutesMeeting(meetingMinutesId, meetingId) {
  return axios
    .delete(`/meeting_minutes/${meetingMinutesId}/meetings/${meetingId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

// Groups
export async function fetchMeetingMinutesGroups(meetingMinutesId, meetingId) {
  return axios
    .get(`/meeting_minutes/${meetingMinutesId}/meetings/${meetingId}/groups`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function createMeetingMinutesGroup(meetingMinutesId, meetingId, payload) {
  return axios
    .post(`/meeting_minutes/${meetingMinutesId}/meetings/${meetingId}/groups`, { group: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function updateMeetingMinutesGroup(meetingMinutesId, meetingId, groupId, payload) {
  return axios
    .put(`/meeting_minutes/${meetingMinutesId}/meetings/${meetingId}/groups/${groupId}`, { group: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function deleteMeetingMinutesGroup(meetingMinutesId, meetingId, groupId) {
  return axios
    .delete(`/meeting_minutes/${meetingMinutesId}/meetings/${meetingId}/groups/${groupId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

// Entries
export async function fetchMeetingMinutesEntries(meetingMinutesId, meetingId, groupId) {
  return axios
    .get(`/meeting_minutes/${meetingMinutesId}/meetings/${meetingId}/groups/${groupId}/entries`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function createMeetingMinutesEntry(meetingMinutesId, meetingId, groupId, payload) {
  return axios
    .post(`/meeting_minutes/${meetingMinutesId}/meetings/${meetingId}/groups/${groupId}/entries`, { entry: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function updateMeetingMinutesEntry(meetingMinutesId, meetingId, groupId, entryId, payload) {
  return axios
    .put(`/meeting_minutes/${meetingMinutesId}/meetings/${meetingId}/groups/${groupId}/entries/${entryId}`, { entry: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function deleteMeetingMinutesEntry(meetingMinutesId, meetingId, groupId, entryId) {
  return axios
    .delete(`/meeting_minutes/${meetingMinutesId}/meetings/${meetingId}/groups/${groupId}/entries/${entryId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

